<script>
import { useCurrentUser } from '@teamwork/use';
import PopoverMenuItem from './PopoverMenuItem.vue';

export default {
  components: {
    PopoverMenuItem,
  },
  setup() {
    const user = useCurrentUser();

    return {
      user,
    };
  },
};
</script>

<template>
  <PopoverMenuItem v-close-popover :route="`/people/${user.id}/tasks`">
    <template #icon>
      <i class="fa fa-tasks" />
    </template>
    <template #title>
      {{ $t('My Tasks') }}
    </template>
  </PopoverMenuItem>
</template>

<style></style>
